const accessNotifications = {

    NOTIFICATIONS: { name: 'Notifications', path: '/notifications' },

}

export default accessNotifications;